/* ==============================================
Collections Carousel (DOT / FRACTION SAFE)
=================================================*/
function initCollectionsCarousel() {
  document.querySelectorAll('.carousel-wrapper:not(.featured-carousel)').forEach(wrapper => {

    if (wrapper.dataset.carouselInit === 'true') return;
    wrapper.dataset.carouselInit = 'true';

    const track = wrapper.querySelector('.carousel-track');
    const prev = wrapper.querySelector('.prev');
    const next = wrapper.querySelector('.next');

    if (!track) return;

    let currentIndex = 0;
    let scrollTimeout;

function getItemsPerPage() {
  if (window.innerWidth < 750) return 2;
  if (window.innerWidth < 990) return 4;
  return 5;
}

function getTotalPages() {
  const totalItems = track.children.length;
  return Math.max(1, Math.ceil(totalItems / getItemsPerPage()));
}

    function goTo(index) {
      const total = getTotalPages();

      currentIndex = Math.max(0, Math.min(index, total - 1));

      track.scrollTo({
        left: currentIndex * track.offsetWidth,
        behavior: 'smooth'
      });
    }

    // arrows
    if (next) next.addEventListener('click', () => goTo(currentIndex + 1));
    if (prev) prev.addEventListener('click', () => goTo(currentIndex - 1));

    // scroll sync
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        currentIndex = Math.round(track.scrollLeft / track.offsetWidth);
      }, 100);
    });

    // resize fix
    window.addEventListener('resize', () => {
      goTo(currentIndex);
    });

  });
}


/* ==============================================
Carousel - hide pagination if not enough categories
=================================================*/

document.querySelectorAll('.subcollections-carousel').forEach((carousel) => {

  const track = carousel.querySelector('.carousel-track');
  const prevBtn = carousel.querySelector('.carousel-arrow.prev');
  const nextBtn = carousel.querySelector('.carousel-arrow.next');

  if (!track || !prevBtn || !nextBtn) return;

  function checkOverflow() {

    requestAnimationFrame(() => {

      const isOverflowing = track.scrollWidth > track.clientWidth + 5;

      if (isOverflowing) {
        prevBtn.style.opacity = '1';
        nextBtn.style.opacity = '1';
        prevBtn.style.pointerEvents = 'auto';
        nextBtn.style.pointerEvents = 'auto';
      } else {
        prevBtn.style.opacity = '0';
        nextBtn.style.opacity = '0';
        prevBtn.style.pointerEvents = 'none';
        nextBtn.style.pointerEvents = 'none';
      }

    });

  }

  // Initial delayed check
  setTimeout(checkOverflow, 100);

  // Recheck after images load
  window.addEventListener('load', checkOverflow);

  // Responsive resize
  window.addEventListener('resize', checkOverflow);

});

/* ==============================================
Sub Collections Carousel - Align center 
=================================================*/

document.querySelectorAll('.subcollections-carousel').forEach((carousel) => {

  const track = carousel.querySelector('.carousel-track');

  if (!track) return;

  function updateCarouselState() {

    requestAnimationFrame(() => {

      const isOverflowing = track.scrollWidth > track.clientWidth + 5;

      track.classList.toggle('no-overflow', !isOverflowing);

      track.classList.add('is-ready');

    });

  }

  window.addEventListener('load', updateCarouselState);

  setTimeout(updateCarouselState, 150);

  window.addEventListener('resize', updateCarouselState);

});


/* ==============================================
Featured Collection Carousel
=================================================*/
function initFeaturedCarousel() {
  document.querySelectorAll('.carousel-wrapper.featured-carousel').forEach(wrapper => {

    if (wrapper.dataset.carouselInit === 'true') return;
    wrapper.dataset.carouselInit = 'true';

    const track = wrapper.querySelector('.carousel-track');
    const prev = wrapper.querySelector('.fc-prev');
    const next = wrapper.querySelector('.fc-next');

    if (!track) return;

    let currentIndex = 0;
    let scrollTimeout;

    function getItemsPerPage() {
      if (window.innerWidth < 750) return 2;
      if (window.innerWidth < 990) return 4;
      return 5;
    }

    function getTotalPages() {
      const totalItems = track.children.length;
      return Math.ceil(totalItems / getItemsPerPage());
    }

    function getPageWidth() {
      return track.offsetWidth;
    }

    function goTo(index) {
      const total = getTotalPages();

      currentIndex = Math.max(0, Math.min(index, total - 1));

      track.scrollTo({
        left: currentIndex * getPageWidth(),
        behavior: 'smooth'
      });
    }

    // arrows
    if (next) next.addEventListener('click', () => goTo(currentIndex + 1));
    if (prev) prev.addEventListener('click', () => goTo(currentIndex - 1));

    // scroll sync
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        currentIndex = Math.round(track.scrollLeft / track.offsetWidth);
      }, 100);
    });

    // resize fix
    window.addEventListener('resize', () => {
      goTo(currentIndex);
    });

  });
}


/* ==============================================
INIT
=================================================*/
function initAllCarousels() {
  initCollectionsCarousel();
  initFeaturedCarousel();
}

document.addEventListener('DOMContentLoaded', initAllCarousels);
document.addEventListener('shopify:section:load', initAllCarousels);



/* ==============================================
Search - JS for active state / overlay / close
=================================================*/
document.addEventListener("DOMContentLoaded", function () {
  const headerSearch = document.querySelector(".header-search");
  if (!headerSearch) return;

  const input = headerSearch.querySelector(".search__input");
  const predictive = headerSearch.querySelector(".predictive-search");
  const overlay = headerSearch.querySelector(".header-search__overlay");
  const closeBtn = headerSearch.querySelector(".header-search__close");

  if (!input || !predictive) return;

  function hasResults() {
    return predictive.querySelector("#predictive-search-results");
  }

  function openSearch() {
    headerSearch.classList.add("is-active");
    document.body.classList.add("search-active");
  }

  function closeSearch() {
    headerSearch.classList.remove("is-active");
    headerSearch.classList.remove("has-results");
    document.body.classList.remove("search-active");
    input.blur();
  }

  function updateState() {
    const hasValue = input.value.trim() !== "";
    const showResults = hasValue && hasResults();

    headerSearch.classList.toggle("has-value", hasValue);
    headerSearch.classList.toggle("has-results", !!showResults);
  }

  input.addEventListener("focus", function () {
    openSearch();
    setTimeout(updateState, 80);
  });

  input.addEventListener("input", function () {
    openSearch();
    setTimeout(updateState, 120);
  });

  input.addEventListener("click", function () {
    openSearch();
    setTimeout(updateState, 80);
  });

  if (overlay) {
    overlay.addEventListener("click", closeSearch);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeSearch);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSearch();
    }
  });

  document.addEventListener("click", function (e) {
    if (!headerSearch.contains(e.target)) {
      closeSearch();
    }
  });

  const observer = new MutationObserver(function () {
    updateState();
  });

  observer.observe(predictive, {
    childList: true,
    subtree: true
  });

  updateState();
});



/* ==============================================
Judge.me - display stars if no review
=================================================*/

function fixJudgeMePreviewBadges() {
  document.querySelectorAll('.product-review-summary .jdgm-preview-badge').forEach(function (badge) {
    badge.style.setProperty('display', 'inline-flex', 'important');

    const prevBadge = badge.querySelector('.jdgm-prev-badge');
    const countEl = badge.closest('.product-review-summary')?.querySelector('.product-review-summary__count');

    if (prevBadge) {
      prevBadge.style.setProperty('display', 'inline-flex', 'important');
    }

    if (countEl && prevBadge) {
      const count = prevBadge.getAttribute('data-number-of-reviews') || 0;
      countEl.textContent = '(' + count + ')';
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  fixJudgeMePreviewBadges();
  setTimeout(fixJudgeMePreviewBadges, 500);
  setTimeout(fixJudgeMePreviewBadges, 1500);
  setTimeout(fixJudgeMePreviewBadges, 3000);
});

/* ==============================================
Judge.me - write a review button trigger pop-up
=================================================*/

// -------------------------------
// Trigger Judge.me popup (GLOBAL)
// -------------------------------
function triggerJudgeMePopup() {

  let attempts = 0;

  const interval = setInterval(() => {

    const btn =
      document.querySelector('[data-testid="write-review-button"]') ||
      document.querySelector('.jdgm-write-rev-link');

    if (btn) {
      btn.click();
      clearInterval(interval);
    }

    if (attempts > 20) {
      clearInterval(interval);
    }

    attempts++;

  }, 200);
}


/* Reviews - smooth scroll to accordion on click  */

document.addEventListener('DOMContentLoaded', () => {

  const reviewBadge = document.querySelector(
    '.product-review-summary .jdgm-prev-badge'
  );

  const reviewsAccordion = document.querySelector(
    '#product-reviews-accordion'
  );

  if (!reviewBadge || !reviewsAccordion) return;

  reviewBadge.style.cursor = 'pointer';

  reviewBadge.addEventListener('click', (e) => {

    e.preventDefault();

    // Open accordion
    if (!reviewsAccordion.hasAttribute('open')) {
      reviewsAccordion.querySelector('summary')?.click();
    }

    // Delay slightly so accordion expands first
    setTimeout(() => {

      const targetY =
        reviewsAccordion.getBoundingClientRect().top +
        window.pageYOffset -
        120;

      const startY = window.pageYOffset;
      const distance = targetY - startY;

      const duration = 800; // higher = slower

      let startTime = null;

      function animation(currentTime) {

        if (!startTime) startTime = currentTime;

        const timeElapsed = currentTime - startTime;

        const progress = Math.min(timeElapsed / duration, 1);

        // easeInOutQuad
        const ease =
          progress < 0.5
            ? 2 * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        window.scrollTo(
          0,
          startY + distance * ease
        );

        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }

      }

      requestAnimationFrame(animation);

    }, 150);

  });

});

// -------------------------------
// Bind widget button (GLOBAL)
// -------------------------------
function bindJudgeMeWidgetButton() {

  const widgetBtn = document.querySelector('.jdgm-write-rev-link');

  if (!widgetBtn) return;

  if (widgetBtn.dataset.bound) return;

  widgetBtn.dataset.bound = "true";

  widgetBtn.addEventListener('click', function (e) {
    e.preventDefault();
    triggerJudgeMePopup();
  });
}


// -------------------------------
// MAIN INIT
// -------------------------------
document.addEventListener('DOMContentLoaded', function () {

  // Custom button
  document.querySelectorAll('.js-write-review').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      triggerJudgeMePopup();
    });
  });

  // Initial bind (important)
  setTimeout(bindJudgeMeWidgetButton, 800);

  // Accordion handling
  const reviewsAccordion = document.querySelector('#product-reviews-accordion');

  if (reviewsAccordion) {
    reviewsAccordion.addEventListener('toggle', function () {

      if (reviewsAccordion.open && window.jdgm && typeof window.jdgm.init === 'function') {

        setTimeout(() => {
          window.jdgm.init();

          // Re-bind after render
          setTimeout(bindJudgeMeWidgetButton, 400);

        }, 200);

      }

    });
  }

  // Fallback (no reviews)
  const container = document.getElementById("judgeme-container");
  const fallback = document.querySelector(".no-reviews");

  if (container && fallback) {
    setTimeout(() => {
      const hasReviews = container.querySelector('.jdgm-rev, .jdgm-row-stars');

      if (!hasReviews) {
        container.style.display = "none";
        fallback.style.display = "block";
      }
    }, 700);
  }

});

/* ==============================================
Accordion - Product Page
=================================================*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-accordion__item').forEach(function (item) {
    const summary = item.querySelector('summary');
    if (!summary) return;

    if (item.hasAttribute('open')) {
      item.classList.add('is-open');
    }

    let isClosing = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      if (isClosing) return;

      if (item.hasAttribute('open')) {
        item.classList.remove('is-open');
        isClosing = true;

        setTimeout(function () {
          item.removeAttribute('open');
          isClosing = false;
        }, 150);
      } else {
        item.setAttribute('open', '');
        requestAnimationFrame(function () {
          item.classList.add('is-open');
        });
      }
    });
  });
});

/* Desktop Drop down menu */

const ANIM_DURATION = 200;

document.querySelectorAll('.header__inline-menu .mega-menu').forEach(menu => {
  let closeTimer;

  const openMenu = () => {
    clearTimeout(closeTimer);

    // close others properly
    document.querySelectorAll('.header__inline-menu .mega-menu').forEach(m => {
      if (m !== menu && m.classList.contains('is-open')) {
        m.classList.remove('is-open');
        m.classList.add('is-closing');

        setTimeout(() => {
          m.open = false;
          m.classList.remove('is-closing');
        }, ANIM_DURATION);
      }
    });

    // OPEN
    menu.open = true;

    menu.classList.remove('is-closing', 'is-open');

    // force reflow
    void menu.offsetWidth;

    menu.classList.add('is-open');
  };

  const closeMenu = () => {
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');

    closeTimer = setTimeout(() => {
      menu.open = false;
      menu.classList.remove('is-closing');
    }, ANIM_DURATION);
  };

  menu.addEventListener('mouseenter', openMenu);
  menu.addEventListener('mouseleave', closeMenu);
});


// STOP Dawn interference
document.querySelectorAll('.header__inline-menu summary').forEach(summary => {
  summary.addEventListener('click', e => {
    e.preventDefault();
  });
});


// Prevent link click from toggling
document.querySelectorAll('.menu-item-link').forEach(link => {
  link.addEventListener('click', e => {
    e.stopPropagation();
  });
});

document.querySelectorAll('.menu-item-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.stopPropagation(); // prevents submenu opening
  });
});



/* ==== Fix for Filter close button ===== */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.mobile-facets__close-btn');
  if (!btn) return;

  const details = btn.closest('details');
  if (details) {
    details.open = false;
  }
});





